
export const bookDefaultCover = 'http://ulms.idufep.com//tongsk/contentmanage/884d17e7-1542-48de-b6dc-414c1f801b32.png'
export const courseDefaultCover = 'https://www.idufep.com/web/static/web/images/courseCover/white.png'
